import Portal from './GIPL_Customer_Portal';
export default Portal;